<template>
  <church-updates-layout :enable-scroll-event="true">
    <div class="bg-[#F2EFED] h-screen overflow-auto no-scrollbar pb-[64px]">
      <div class="sticky top-0 px-[20px] bg-[#F2EFED] z-10">
        <BackButton />
        <ChurchUpdatesHeader class="pt-[16px] pb-[24px]"></ChurchUpdatesHeader>
      </div>
      <SkeletonChurchUpdates v-if="isLoading" />
      <Updates
        v-else-if="churchUpdates.length > 0"
        :updates="churchUpdates"
        @open-church-update="openChurchUpdate"
      >
      </Updates>
    </div>
  </church-updates-layout>
</template>

<script>
import { mapState } from 'vuex';
import ChurchUpdatesHeader from '@/components/ChurchUpdatesPage/Header.vue';
import Updates from '@/components/ChurchUpdatesPage/Updates.vue';
import SkeletonChurchUpdates from '@/components/ChurchUpdatesPage/SkeletonChurchUpdates.vue';
import BackButton from '@/components/common/BackButton.vue';
import ChurchUpdatesLayout from '../../components/ChurchUpdatesLayout.vue';
import { openUrl } from '@/utils/browser-helper';

export default {
  components: {
    Updates,
    SkeletonChurchUpdates,
    ChurchUpdatesHeader,
    BackButton,
    ChurchUpdatesLayout,
  },
  data() {
    return {
      hasLoaded: false,
    };
  },
  computed: {
    ...mapState('churchUpdates', ['churchUpdates', 'isLoading', 'categories']),
  },
  methods: {
    async openChurchUpdate(slug, isExternalLink) {
      // Normalize slug - extract just the slug part if it comes as a full path from Storyblok
      const normalizedSlug =
        slug && typeof slug === 'string' ? slug.replace(/^.*\//, '').replace(/\/+$/, '') : slug;

      if (isExternalLink) {
        await openUrl(
          {
            url: 'https://hogcstories.com/' + normalizedSlug,
          },
          {
            title: normalizedSlug,
            source: 'church-updates',
            page: 'ChurchUpdates',
          },
        );
      } else {
        this.$router.push(`/church-updates/${normalizedSlug}`);
      }
    },
  },
  async ionViewWillEnter() {
    await this.$store.dispatch('profile/fetchProfile');
    await this.$store.dispatch('churchUpdates/getChurchUpdates');

    // Redirect if no updates available (backend PAC filtering returned nothing)
    if (!this.churchUpdates || this.churchUpdates.length === 0) {
      this.$router.push('/home');
      return;
    }

    this.hasLoaded = true;
  },
};
</script>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
